import { render } from "./VUEPopupDataAllineamento.vue?vue&type=template&id=80467d48"
import script from "./VUEPopupDataAllineamento.vue?vue&type=script&lang=js"
export * from "./VUEPopupDataAllineamento.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__